enum BiddingSteps {
  NONE = 0,
  ONCE = 1,
  TWICE = 2,
  COMPLETE_LOT = 3,
}

export default BiddingSteps;
